export const EVENT_MODULES_FIELD_EVENT_TYPES = [
  'course',
  'education',
  'exercise',
  'activity',
] as const;

export type EventModulesFieldEventType =
  (typeof EVENT_MODULES_FIELD_EVENT_TYPES)[number];

export const EVENT_MODULES_FIELD_TYPE_LABELS: Record<
  EventModulesFieldEventType,
  string
> = {
  course: 'Kursus',
  education: 'Uddannelse',
  exercise: 'Øvelse',
  activity: 'Aktivitet',
};

export function modulesFieldEnabledOrgKey(eventType: string): string {
  return `events_modules_field_${eventType}_enabled`;
}
